import { isEqual } from 'lodash-es';
import { PostalAddress, ProvinceModel } from '../models';

// Validation patterns for address-related fields
export const RECIPIENT_NAME_PATTERN = /^.{2,}\ .{2,}/;
export const POSTAL_CODE_PATTERN = /^(?:0[1-9]|[1-4]\d|5[0-2])\d{3}$/;
export const PHONE_PATTERN = /^[0-9]*$/;
export const PHONE_MIN_LENGTH = 9;
export const PHONE_MAX_LENGTH = 9;
export const POSTAL_CODE_LENGTH = 5;

export function newAddress(): PostalAddress {
  return {
    recipient: '',
    street: '',
    number: '',
    floor: '',
    addressLine1: '',
    city: '',
    province: '',
    provinceId: null,
    postalCode: '',
    country: '',
    phone: '',
    taxId: '',
  };
}

export function buildAddressLine1(street: string, number: string, floor?: string): string {
  return `${street}, ${number}${floor ? ', ' + floor : ''}`;
}

export function normalizeTaxId(taxId: string): string {
  return taxId.toUpperCase().replace(/\s/g, '');
}

export function findProvinceByPostalCode(
  postalCode: string,
  provinces: ProvinceModel[]
): { name: string; id: string; } | null {
  if (!postalCode || postalCode.length !== 5 || !provinces.length) return null;
  const provinceCode = postalCode.split('').slice(0, 2).join("");
  const province = provinces.find(p => p.provincia_id === provinceCode);
  return province ? { name: province.nombre, id: provinceCode } : null;
}

/**
 * Compares two addresses excluding contact information (phone, email, organization).
 * @param addr1 The first address to compare.
 * @param addr2 The second address to compare.
 * @returns True if the addresses are equal excluding contact information, false otherwise.
 */
export function areAddressesEqualExcludingContactInfo(addr1: PostalAddress, addr2: PostalAddress): boolean {
  const { phone: _p1, email: _e1, organization: _o1, ...rest1 } = addr1 || {};
  const { phone: _p2, email: _e2, organization: _o2, ...rest2 } = addr2 || {};
  return isEqual(rest1, rest2);
}
